import window from "@shared/utils/app-window.ts";
import { LocalStorageKeys } from "@shared/types/localTypes/storage.ts";
import { AlertProps } from "@shared/types/localTypes/props.ts";

export const useLoginMessage = () => {
  const setLoginMessage = ({ description, type }: AlertProps) => {
    window.sessionStorage.setItem(
      LocalStorageKeys.LOGIN_MESSAGE,
      JSON.stringify({ description, type }),
    );
  };

  const clearMessages = () => {
    setLoginMessage({ description: "", type: "error" });
  };

  const getLoginMessage = (): AlertProps => {
    const errorMessage = window.sessionStorage.getItem(
      LocalStorageKeys.LOGIN_MESSAGE,
    );

    if (!errorMessage) {
      return { description: "", type: "error" };
    }

    return JSON.parse(errorMessage) as AlertProps;
  };

  return {
    setLoginMessage,
    getLoginMessage,
    clearMessages,
  };
};
